export default __webpack_public_path__ + "static/media/Social Links.9f6f38e6.svg";